import { createContext, useEffect, useState } from "react";
import { getCookie } from "../../App";
import { BTCWebsocket, WalletWebsocket } from "./WalletWebSocket";
import { domain } from "../Links/Links";
import axios from "axios";
import { WalletRequest } from "./WalletRequest";
export const WalletContext = createContext();

function WalletProvider({ children }) {
  const [tokensInfo, setTokensInfo] = useState([]);

  const [inactiveWalletMessage, setInactiveWalletMessage] = useState(null);

  const [trxAPIData, setTRXAPIData] = useState([]);


  const [requestStatus, setRequestStatus] = useState(false);

  useEffect(() => {
    WalletWebsocket(setTRXAPIData);

    setRequestStatus(true);

    WalletRequest(
      setTokensInfo,
      setRequestStatus,
      setInactiveWalletMessage,
    );
    
  }, []);

  return (
    <WalletContext.Provider
      value={{
        tokensInfo,
        setTokensInfo,
        inactiveWalletMessage,

        trxAPIData,

        requestStatus,
      }}
    >
      {children}
    </WalletContext.Provider>
  );
}

export default WalletProvider;
